


























































































































































































































































































































import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'

@Component
export default class FinanceiroGerenciamentoEquipes extends Vue {
  visibleResults: number = 5
  formValido: boolean = true
  showModalEquipe: boolean = false
  showModalDelete: boolean = false
  loadDelete: boolean = false
  // O template ja usava :loading="loadingSalvar" e :loading="loadingTabela", mas nenhum
  // dos dois campos existia na classe - o indicador de carregando nunca aparecia.
  loadingSalvar: boolean = false
  loadingTabela: boolean = false
  // Nome da equipe que o modal de exclusao esta confirmando, para o usuario ver o que apaga.
  nomeEquipeParaExcluir: string = ''
  procedimentoSelecionado: any = null
  buscaProcedimento: string = ''
  loadingProcedimentos: boolean = false
  
  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get totalPaginas() {
    // O divisor tem de ser o mesmo tamanho de página enviado ao servidor, senão o
    // paginador oferece páginas que não existem (FXSR-2844).
    const porPagina = this.getRecebimentoStore.qtdPorPaginaEquipes
    return Math.ceil(this.getRecebimentoStore.totalEquipesList / porPagina)
  }

  get equipesPaginadas() {
    return this.getRecebimentoStore.equipesAllList
  }

  get isEdit() {
    return this.getRecebimentoStore.isEditEquipe
  }

  set isEdit(value: boolean) {
    this.getRecebimentoStore.setIsEditEquipe(value)
  }

  get paginaAtual() {
    return this.getRecebimentoStore.paginaEquipes
  }

  set paginaAtual(value: number) {
    this.getRecebimentoStore.setPaginaEquipes(value)
  }

  get searchGerenciamentoEquipe() {
    return this.getRecebimentoStore.searchGerenciamentoEquipe
  }

  set searchGerenciamentoEquipe(value: string) {
    this.getRecebimentoStore.setSearchGerenciamentoEquipe(value)
  }

  get headersEquipes() {
    return [
      { text: 'Nome', value: 'nome', align: 'start', sortable: false },
      // { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
      { text: 'Criado por', value: 'createdByNome', align: 'center', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false },
    ]
  }

  get nomeEquipe() {
    return this.getRecebimentoStore.nomeEquipe
  }

  set nomeEquipe(value: string) {
    this.getRecebimentoStore.setNomeEquipe(value)
  }

  get descricaoEquipe() {
    return this.getRecebimentoStore.descricaoEquipe
  }

  set descricaoEquipe(value: string) {
    this.getRecebimentoStore.setDescricaoEquipe(value)
  }

  get filtrarPorProcedimentos() {
    return this.getRecebimentoStore.filtrarPorProcedimentos
  }

  set filtrarPorProcedimentos(value: boolean) {
    this.getRecebimentoStore.setFiltrarPorProcedimentos(value)
  }

  get procedimentosEquipes() {
    return this.getRecebimentoStore.procedimentosEquipes
  }
  
  set procedimentosEquipes(value: string[]) {
    this.getRecebimentoStore.setProcedimentosEquipes(value)
  }

  get filtrarPorHospital() {
    return this.getRecebimentoStore.filtrarPorHospital
  }

  set filtrarPorHospital(value: boolean) {
    this.getRecebimentoStore.setFiltrarPorHospital(value)
  }

  get hospitalEquipe() {
    return this.getRecebimentoStore.hospitalEquipe
  }

  set hospitalEquipe(value: string) {
    this.getRecebimentoStore.setHospitalEquipe(value)
  }

  get procedimentos() {
    return this.getRecebimentoStore.procedimentosList
  }

  get procedimentosSelecionados() {
    return this.getRecebimentoStore.procedimentosEquipesDetalhe
  }

  get buscaValidaParaPesquisar() {
    return !!this.buscaProcedimento && this.buscaProcedimento.length >= 3
  }

  buscaProcedimentoDebounced = _.debounce(
    (termo: string) => this.getRecebimentoStore.getProcedimentosList(termo),
    500,
  )

  @Watch('buscaProcedimento')
  async onBuscaProcedimentoChanged(termo: string) {
    if (!termo || termo.length < 3) {
      return
    }

    this.loadingProcedimentos = true
    await this.buscaProcedimentoDebounced(termo)
    this.loadingProcedimentos = false
  }

  @Watch('procedimentoSelecionado')
  onProcedimentoSelecionado(procedimento: any) {
    if (!procedimento || !procedimento.codigo) {
      return
    }

    this.getRecebimentoStore.adicionarProcedimentoEquipe({
      valor: procedimento.codigo,
      rotulo: procedimento.rotulo || procedimento.codigo,
    })

    // Limpa o campo para o proximo, em vez de deixar o ultimo escolhido preso nele.
    this.$nextTick(() => {
      this.procedimentoSelecionado = null
      this.buscaProcedimento = ''
    })
  }

  removerProcedimento(valor: string) {
    this.getRecebimentoStore.removerProcedimentoEquipe(valor)
  }

  get hospitais() {
    return this.getRecebimentoStore.fontesPagadoras
  }

  get loadinDelete() {
    return this.loadDelete
  }

  set loadingDelete(value: boolean) {
    this.loadDelete = value
  }

  openModalDelete(item: any) {
    this.getRecebimentoStore.setDeleteId(item.id)
    this.nomeEquipeParaExcluir = item.nome
    this.showModalDelete = true
  }

  filtroDebounced = _.debounce(() => this.filter(), 500)

  // Chamado a cada tecla. Sem o debounce, digitar "cardiologia" disparava 11
  // requisicoes e a ultima a responder vencia - o resultado exibido podia nao
  // corresponder ao que estava no campo.
  aplicarFiltro(item: any) {
    this.searchGerenciamentoEquipe = item
    // Filtro novo recomeça da primeira página: sem isso a tela continua pedindo a
    // página em que estava e volta vazia quando o resultado filtrado é menor.
    this.paginaAtual = 1
    this.filtroDebounced()
  }

  // Enter na busca nao espera o debounce. Sem parametro de proposito: keyup entrega o
  // KeyboardEvent, nao o texto - o v-model do campo ja mantem o termo atualizado.
  async aplicarFiltroImediato() {
    this.paginaAtual = 1
    this.filtroDebounced.cancel()
    await this.filter()
  }

  // Ponto unico de carga da listagem: e o unico lugar que liga o indicador de
  // carregando e o unico que reporta falha de busca ao usuario.
  async filter() {
    this.loadingTabela = true

    try {
      const response = await this.getRecebimentoStore.getEquipesAll()

      if (response && response.success === false) {
        const erro = response.message || 'Não foi possível carregar as equipes.'
        EventBus.$emit('setSnackbar', getSnackbarMessage(erro, 'error'))
      }
    } finally {
      this.loadingTabela = false
    }
  }

  abrirModalCriar() {
    this.isEdit = false
    this.resetForm()
    this.showModalEquipe = true
  }

  async abrirModalEditar(equipe: any) {
    this.isEdit = true
    await this.getRecebimentoStore.setEquipeEdit(equipe)
    this.getRecebimentoStore.setEquipeId(equipe.id)
    this.showModalEquipe = true
  }

  async abrirModalProfissionais(equipe: any) {
    this.getRecebimentoStore.setModalProfissionais(true)
    this.getRecebimentoStore.setEquipeId(equipe.id)
    // Abre sempre na primeira página e sem o filtro da equipe anterior.
    this.getRecebimentoStore.resetPaginacaoProfissionaisEquipe()
    await this.getRecebimentoStore.getProfissionaisEquipeMedica()
    this.getRecebimentoStore.setModalTabelaProfissionais(true)
  }

  async abrirModalRegraEquipe(equipe: any) {
    this.getRecebimentoStore.setEquipeId(equipe.id)
    await this.getRecebimentoStore.getRegrasEquipeMedica()
    this.getRecebimentoStore.setModalTabelaRegras(true)
  }

  async getResults(pagina: number) {
    this.paginaAtual = pagina
    await this.filter()
  }

  fecharModalEquipe() {
    this.showModalEquipe = false
  }

  resetForm() {
    this.getRecebimentoStore.resetEquipeForm()
  }

  async deleteItem() {
    this.loadingDelete = true

    try {
      const response = await this.getRecebimentoStore.deleteEquipeMedica()

      // Antes o retorno era ignorado: o modal fechava e a lista recarregava mesmo em
      // falha, entao uma exclusao que nao aconteceu parecia ter dado certo.
      if (!response.success) {
        const erro = response.message || 'Não foi possível excluir a equipe.'
        EventBus.$emit('setSnackbar', getSnackbarMessage(erro, 'error'))
        return
      }

      this.showModalDelete = false
      await this.filter()
      EventBus.$emit('setSnackbar', getSnackbarMessage('Equipe excluída com sucesso!', 'success'))
    } finally {
      this.loadingDelete = false
    }
  }

  async salvarEquipe() {
    // O Enter no campo de nome cai aqui igual ao clique em Salvar, entao a guarda
    // de reentrada importa: sem ela, dois Enter seguidos criam a equipe duas vezes.
    if (this.loadingSalvar) {
      return
    }

    if (!(this.$refs.formEquipe as any).validate()) {
      return
    }

    this.loadingSalvar = true

    try {
      const response = await this.getRecebimentoStore.salvarEquipe()

      // Sem isto a falha era silenciosa: o modal ficava aberto sem mensagem nenhuma
      // e o usuario nao tinha como saber se salvou.
      if (!response.success) {
        const erro = response.message || 'Não foi possível salvar a equipe.'
        EventBus.$emit('setSnackbar', getSnackbarMessage(erro, 'error'))
        return
      }

      const mensagem = this.isEdit ? 'Equipe atualizada com sucesso!' : 'Equipe criada com sucesso!'

      this.fecharModalEquipe()
      await this.filter()
      EventBus.$emit('setSnackbar', getSnackbarMessage(mensagem, 'success'))
    } finally {
      this.loadingSalvar = false
    }
  }

  formatData(date: string) {
    return new Date(date).toLocaleDateString('pt-BR')
  }

  async init() {
    // A lista de procedimentos nao e mais carregada aqui: eram ~7 mil registros puxados
    // no load da tela. Agora vem por busca no servidor, sob demanda.
    await this.filter()
    await this.getRecebimentoStore.getFontePagadoraAll()
    await this.getRecebimentoStore.getPrestadores({})
  }
  
  async mounted() {
    await this.init()
  }
  
}
